import { List, Map } from 'immutable';

import { TYPES } from './actions';
import { SESSION_DESTROY } from '../../actions';
import Logger from '../../../lib/Logger';

const initialState = Map({
  isLoading: false,
  isLoadingJournalCount: false,
  pages: {},
  total: null,
  unreadJournalCount: 0,
  unreadJournalCountByCareGuide: Map(),
  form: {},
  viewingPage: 1,
});

export default function alerts(state = initialState, action) {
  Logger.log('debug', `[state.alerts.reducers] alerts(%j, %j)`, state, action);

  switch (action.type) {
    case TYPES.LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          total: action.total,
          new: action.new,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case TYPES.LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.PATCH_REQUEST:
      return state.mergeDeep({
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.PATCH_SUCCESS:
      return state.mergeDeep({
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.PATCH_FAILURE:
      return state
        .mergeDeep({
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.SET_VIEWING_PAGE:
      return state.mergeDeep({
        viewingPage: action.page,
      });

    case TYPES.COUNT_JOURNAL_REQUEST:
      return state.mergeDeep({
        isLoadingJournalCount: true,
        careGuideId: action.careGuideId,
      });

    case TYPES.COUNT_JOURNAL_SUCCESS:
      if (action.careGuideId) {
        return state
          .mergeDeep({
            isLoadingJournalCount: false,
            lastUpdated: action.receivedAt,
            careGuideId: action.careGuideId,
          })
          .setIn(['unreadJournalCountByCareGuide', action.careGuideId], action.count);
      } else {
        return state.mergeDeep({
          isLoadingJournalCount: false,
          unreadJournalCount: action.count,
          lastUpdated: action.receivedAt,
          careGuideId: action.careGuideId,
        });
      }

    case TYPES.COUNT_JOURNAL_FAILURE:
      return state.mergeDeep({
        isLoadingJournalCount: false,
        careGuideId: action.careGuideId,
      });

    case SESSION_DESTROY:
      return initialState;

    default:
      return state;
  }
}

Logger.log('silly', `state.alerts.reducers loaded.`);
